/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/ApprovalMatrixToolbar.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Approval Matrix
 *
 * PURPOSE:
 * Search & Filter Toolbar
 *
 * RESPONSIBILITY:
 * • Search
 * • Workflow Filter
 * • Department Filter
 * • Status Filter
 * • Refresh
 * • Create Rule
 *
 ******************************************************************************/

import React from "react";

export default function ApprovalMatrixToolbar({

    filters,

    workflows = [],

    departments = [],

    onFilterChange,

    onSearch,

    onReset,

    onRefresh,

    onCreate,

}) {

    return (

        <div
            className="card shadow-sm mb-3"
            style={{
                borderRadius: "10px",
            }}
        >

            <div className="card-body">

                <div className="row">

                    {/* ------------------------------------------------ */}
                    {/* SEARCH */}
                    {/* ------------------------------------------------ */}

                    <div className="col-md-3 mb-2">

                        <label className="form-label">

                            Search

                        </label>

                        <input

                            type="text"

                            className="form-control"

                            placeholder="Workflow / Remarks"

                            value={filters.search || ""}

                            onChange={(e) =>

                                onFilterChange(

                                    "search",

                                    e.target.value

                                )

                            }

                        />

                    </div>

                    {/* ------------------------------------------------ */}
                    {/* WORKFLOW */}
                    {/* ------------------------------------------------ */}

                    <div className="col-md-3 mb-2">

                        <label className="form-label">

                            Workflow

                        </label>

                        <select

                            className="form-control"

                            value={filters.workflow_id || ""}

                            onChange={(e) =>

                                onFilterChange(

                                    "workflow_id",

                                    e.target.value

                                )

                            }

                        >

                            <option value="">

                                All Workflows

                            </option>

                            {workflows.map((workflow) => (

                                <option

                                    key={workflow.workflow_id}

                                    value={workflow.workflow_id}

                                >

                                    {workflow.name}

                                </option>

                            ))}

                        </select>

                    </div>

                    {/* ------------------------------------------------ */}
                    {/* DEPARTMENT */}
                    {/* ------------------------------------------------ */}

                    <div className="col-md-2 mb-2">

                        <label className="form-label">

                            Department

                        </label>

                        <select

                            className="form-control"

                            value={filters.department_id || ""}

                            onChange={(e) =>

                                onFilterChange(

                                    "department_id",

                                    e.target.value

                                )

                            }

                        >

                            <option value="">

                                All

                            </option>

                            {departments.map((department) => (

                                <option

                                    key={department.department_id}

                                    value={department.department_id}

                                >

                                    {department.name}

                                </option>

                            ))}

                        </select>

                    </div>

                    {/* ------------------------------------------------ */}
                    {/* STATUS */}
                    {/* ------------------------------------------------ */}

                    <div className="col-md-2 mb-2">

                        <label className="form-label">

                            Status

                        </label>

                        <select

                            className="form-control"

                            value={filters.is_active ?? ""}

                            onChange={(e) =>

                                onFilterChange(

                                    "is_active",

                                    e.target.value

                                )

                            }

                        >

                            <option value="">

                                All

                            </option>

                            <option value="true">

                                Active

                            </option>

                            <option value="false">

                                Inactive

                            </option>

                        </select>

                    </div>

                    {/* ------------------------------------------------ */}
                    {/* ACTION BUTTONS */}
                    {/* ------------------------------------------------ */}

                    <div
                        className="
                            col-md-2
                            d-flex
                            align-items-end
                            justify-content-end
                        "
                    >

                        <button

                            className="btn btn-outline-secondary me-2"

                            onClick={onReset}

                        >

                            Reset

                        </button>

                        <button

                            className="btn btn-primary me-2"

                            onClick={onSearch}

                        >

                            Search

                        </button>

                        <button

                            className="btn btn-outline-primary me-2"

                            onClick={onRefresh}

                        >

                            Refresh

                        </button>

                        <button

                            className="btn btn-success"

                            onClick={onCreate}

                        >

                            + Rule

                        </button>

                    </div>

                </div>

            </div>

        </div>

    );

}